import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

let _instance: PublicClientApplication | null = null;
let _initPromise: Promise<PublicClientApplication> | null = null;

export function getMsalInstance(): PublicClientApplication | null {
  return _instance;
}

export async function initializeMsalInstance(): Promise<PublicClientApplication> {
  if (_instance) return _instance;
  if (_initPromise) return _initPromise;
  if (typeof window === 'undefined') {
    throw new Error('initializeMsalInstance must run on the client');
  }

  _initPromise = (async () => {
    const instance = new PublicClientApplication(msalConfig);

    instance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as { account?: { homeAccountId: string } };
        if (payload.account) {
          instance.setActiveAccount(instance.getAccount({ homeAccountId: payload.account.homeAccountId }));
        }
      }
    });

    await instance.initialize();

    try {
      const response = await instance.handleRedirectPromise();
      if (response?.account) {
        instance.setActiveAccount(response.account);
      }
    } catch {
      console.warn('Cleared stale MSAL redirect state');
    }

    const accounts = instance.getAllAccounts();
    if (accounts.length > 0 && !instance.getActiveAccount()) {
      instance.setActiveAccount(accounts[0]);
    }

    _instance = instance;
    return instance;
  })();

  return _initPromise;
}
